import { HrObjectType } from './HrObjectType';

export const HrObjectTypeMatchRequireds = {
	[HrObjectType.Users]: 'matchedCode',
	[HrObjectType.Positions]: 'matchedCode',
	[HrObjectType.Department]: 'matchedCode',
	[HrObjectType.Professions]: 'matchedCode',
	[HrObjectType.Groups]: 'matchedCode',
	[HrObjectType.PropertyTypes]: 'matchedCode',
	[HrObjectType.ManagerKeys]: 'matchedDescription'
};
